import {Routes} from '@angular/router';
import {routes as projectDetailsRoutes} from '@catdetails/project-details.routing';
import {GlobalProjectComponent} from '@catproject/components/global-project/global-project.component';
import {TypeSwitchComponent} from '@catproject/components/type-switch/type-switch.component';
import {ProjectListComponent} from './components/project-list/project-list.component';
import {ProjectPropertiesComponent} from "@catdetails/components";

const localRoutes: Routes = [
  {
    path: 'new',
    children: [
      {
        path: '',
        component: TypeSwitchComponent,
      },
      {
        path: 'vip',
        component: ProjectPropertiesComponent,
      },
      {
        path: 'global',
        component: GlobalProjectComponent,
      },
    ],
  },
];
const childRoutes = localRoutes.concat(projectDetailsRoutes);

export const routes: Routes = [
  {
    path: '',
    component: ProjectListComponent,
    children: childRoutes,
  },
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project/project.routing.ts